(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular
    .module('app')
    .component('declineBookingItemNotificationProvider', declineBookingItemNotificationProvider());

  function declineBookingItemNotificationProvider() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        subdomain: '<',
        companyApiKey: '<',
        onBookingItemNotificationDeclined: '&',
      },
      controller: DeclineBookingItemNotificationProviderComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/booking-item-notification-provider/' +
        'decline-notification/decline-booking-item-notification-provider.component.html',
    };
  }

  DeclineBookingItemNotificationProviderComponent.$inject = [
    'UtilService',
    'BookingItemNotificationProviderService',
  ];

  function DeclineBookingItemNotificationProviderComponent(
    UtilService,
    BookingItemNotificationProviderService
  ) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.declineBookingNotification = declineBookingNotification;

    function declineBookingNotification(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      vm.notification.status = 'declined';

      let params = {
        notificationUrl: null,
        obj: null,
      };

      // Booking item != Booking it service item
      if (!vm.bookingItemServiceItem) {
        params.notificationUrl = 'booking_item_notifications_provider';
        params.obj = { booking_item_notification: vm.notification };
      } else {
        params.notificationUrl = 'booking_item_service_item_notifications_provider';
        params.obj = { booking_item_service_item_notification: vm.notification };
      }

      vm.sendingForm = true;
      BookingItemNotificationProviderService.saveBookingItemNotificationProvider(
        vm.notification,
        vm.subdomain,
        vm.companyApiKey,
        params,
        null
      ).then(function (response) {
        let data = {
          status: response.data.status,
        };

        vm.onBookingItemNotificationDeclined({ dataObj: data });

        vm.sendingForm = false;
      });
    }
  }
})();
